<h2 class="emptyJobCardList" *ngIf="jobBoardCardData && !objectKeys(jobBoardCardData)?.length">No Cards to show</h2>
<div class="d-flex justify-content-between">
  <div class="cards-container mt-3">
    <div *ngFor="let groupByValue of objectKeys(jobBoardCardData); let i = index; trackBy: trackByGroupBy">
      <div class="container p-0">
        <div *ngIf="jobBoardCardData[groupByValue]?.length" class="Nav">
          <h3 *ngIf="groupByValue != 'none'" class="text-uppercase ml-0 mt-3 mb-2">{{ groupByValue }}</h3>
        </div>
        <div *ngFor="let data of jobBoardCardData[groupByValue]; trackBy: trackByCardId" class="card-container">
          <div class="Card-1">
            <app-job-card
              [id]="id"
              [tagAssignments]="jobBoardTagAssignments"
              [selectedCard]="cardSideNavData"
              (openEmployeeSideNav)="onOpenEmployeeSideNav($event)"
              (openJobSideNavBar)="onOpenJobSideNav($event)"
              [cardDepartment]="groupByValue"
              [staticData]="staticData"
              [cardData]="data"></app-job-card>
          </div>
        </div>
      </div>
      <div class="card-divider"></div>
    </div>
  </div>
  <div class="Sidebar" *ngIf="isEmployeeSideNavOpen || isSideNavOpen">
    <app-job-board-sidenav
      [cardData]="cardSideNavData"
      [cardType]="cardType"
      [tagData]="tagAssignments"
      [@openClose]="isSideNavOpen ? 'open' : 'closed'"
      (closeSideNav)="closeSideNavBar($event)"></app-job-board-sidenav>
    <app-job-board-profile-sidenav
      [employeeData]="employeeCardSideNavData"
      [tagData]="tagAssignments"
      [@openClose]="isEmployeeSideNavOpen ? 'open' : 'closed'"
      (closeEmployeeSideNav)="closeEmployeeSideNavBar($event)"></app-job-board-profile-sidenav>
  </div>
</div>
